import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/tehtanje";

export const fetchWeighingPage = createAsyncThunk(
  "weighing/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createWeighing = createAsyncThunk(
  "weighing/create",
  async (weighing, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, weighing);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const weighingSlice = createSlice({
  name: "weighing",
  initialState: {
    page: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWeighingPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchWeighingPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchWeighingPage.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createWeighing.fulfilled, (state, _) => {
        state.isLoading = false;
      })
      .addCase(createWeighing.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createWeighing.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default weighingSlice.reducer;
